import { MouseEventHandler } from "react";
import { ReactComponent as UnGroupIcon} from "./../../icons/ungroup_folder.svg";
import './CustomIconButton.scss';
import React from "react";

export type CustomIconButtonProps = {
    icon: "ungroup";
    size?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
    onClick? : MouseEventHandler<HTMLButtonElement>;
}

const CustomIconButton = React.forwardRef<HTMLButtonElement, CustomIconButtonProps> (({icon, size, onClick}, forwardRef) => {

    const renderIcon = (icon:string) => {
        const iconSize = size ? size * 4 : 16 ;
        switch (icon) {
            case "ungroup":
                return <UnGroupIcon width={iconSize} height={iconSize} />
        }
    }

    return (
        <button className="tcsp-icon-button" onClick={onClick} ref={forwardRef} >
            {icon && (
                renderIcon(icon)
            )}
        </button>
    );
});

export default CustomIconButton;